<figure class="not-found">
  <img class="not-found-image" [src]="fetchImage()" />
</figure>
<h3 class="n_dta">
  {{ getTranslationKey(type) | translate }}
</h3>
